import { createForm } from '@formily/core';
import { ExpressionScope, FormProvider } from '@formily/react';
import { Scope } from '@micun/form-expression';
import { ScopeContext } from '@micun/form-expression/react/index';
import React, { forwardRef, useImperativeHandle, useMemo } from 'react';
import { MessageProvider, ModalProvider } from "./hooks";
import { FetchContext, FetchProvider } from "./hooks/useFetch";
import { Render } from "./internal";
export var FormRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var options = props.options,
    form = props.form,
    fetchOption = props.fetchOption,
    context = props.context,
    children = props.children;
  var internalForm = useMemo(function () {
    return form || createForm(options);
  }, []);
  useImperativeHandle(ref, function () {
    return internalForm;
  });
  return /*#__PURE__*/React.createElement(FetchProvider, fetchOption, /*#__PURE__*/React.createElement(FetchContext.Consumer, null, function (fetch) {
    var scope = {
      JSON: JSON,
      console: console,
      context: context,
      fetch: fetch,
      form: internalForm,
      // wx,
      // Taro,
      React: React
      // ENV,
      // fetch,
    };
    return /*#__PURE__*/React.createElement(MessageProvider, null, /*#__PURE__*/React.createElement(ModalProvider, null, /*#__PURE__*/React.createElement(FormProvider, {
      form: internalForm
    }, /*#__PURE__*/React.createElement(ExpressionScope, {
      value: scope
    }, /*#__PURE__*/React.createElement(ScopeContext.Provider, {
      value: {
        scope: new Scope({
          context: scope
        })
      }
    }, children, /*#__PURE__*/React.createElement(Render, null))))));
  }));
});